'use strict';

var BASE_URL = 'https://downloads-dev.sandbox.dbt.svs.nike.com/',
  DOWNLOAD_URL = {
    base: BASE_URL,
  };

module.exports = DOWNLOAD_URL;
